import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { store } from './app/store';
import { RouterProvider } from 'react-router-dom';
import appRouter from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
// Importing the Bootstrap CSS; Alternative is via CDN in index.html 
// Cf: https://github.com/react-bootstrap/code-sandbox-examples/blob/master/README.md 
import 'bootstrap/dist/css/bootstrap.min.css';

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
    <Provider store={store}>
      <RouterProvider router={appRouter} />
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
